export const CSRF_TOKEN = {
  apiUrl: "/api/GetToken"
}